export default __webpack_public_path__ + "static/media/logo1.e82fae63.png";